import request from '@/utils/request'
import { Notification } from 'element-ui'

export function login(data) {
  return request({
    url: '/admin/doLogin',
    method: 'post',
    data
  })
}

export async function getInfo() {
  const res = await request({
    url: '/admin/getInfo',
    method: 'post'
  })
  if (res.code === 200) {
    const data = res.body.data
    if (data.roles == null || data.roles.length <= 0) {
      Notification.warning('该账号未授权，无法登录')
    }
  }
  return res
}

/**
 * 获取后台用户类型
 */
export function getUserType() {
  return request({
    url: '/admin/getUserType',
    method: 'post'
  })
}

export function getBaseInfo() {
  return request({
    url: '/admin/getBaseInfo',
    method: 'post'
  })
}

export function addUser(SysUser) {
  return request({
    url: '/admin/insert',
    method: 'post',
    data: SysUser
  })
}

export function editUser(SysUser) {
  return request({
    url: '/admin/editSysUser',
    method: 'post',
    data: SysUser
  })
}

export function changeStatus(data) {
  return request({
    url: '/admin/editStatus',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}
